import { Component, inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalReservationComponent } from '../../shared/components/modal-reservation/modal-reservation.component';

@Component({
    selector: 'madero-reservation',
    imports: [],
    templateUrl: './reservation.component.html',
    styleUrl: './reservation.component.scss'
})
export class ReservationComponent implements OnInit {
  #dialog = inject(MatDialog);

  ngOnInit(): void {
    this.onOpenRegister();
  }

  onOpenRegister(): void {
    this.#dialog
      .open(ModalReservationComponent, {
        width: '550px',
        data: { editMode: false },
        disableClose: true,
      })
      .afterClosed()
      .subscribe((response) => {
        console.log('Close: ', response);
      });
  }
}
